import {List, Typography} from '@mui/material';
import LandingFeatureItem from './LandingFeatureItem';

export default function LandingFeature() {
  return (
    <>
      <Typography variant="h2" gutterBottom>
        📌 What You Can Do Right Now
      </Typography>
      <List>
        <LandingFeatureItem text="Bulk download & upload titles and tags to optimize SEO effortlessly." />
        <LandingFeatureItem text="Create digital listing and generate PDF files with link to download the content" />
        <LandingFeatureItem text="Bulk upload listing directly from Google Drive" />
      </List>
    </>
  );
}
